import { useState } from 'react';
import styles from './ForgotPassword.module.css';
import AuthService from '../../../services/auth/AuthService';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError('');

    if (!email) {
      setError('Please enter your email address.');
      return;
    }

    try {
      setLoading(true);
      await AuthService.forgotPassword(email);
      // Always show the same success state regardless of whether the email exists.
      // This prevents account-enumeration via response timing or messaging.
      setSubmitted(true);
    } catch {
      // Same here: surface a generic, non-enumerating message on failure.
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>

        {submitted ? (
          <div className={styles.successState}>
            <div className={styles.successIcon}>✓</div>
            <h1 className={styles.heading}>Check your inbox</h1>
            <p className={styles.subheading}>
              We've sent a password reset link to <strong>{email}</strong>.
              It may take a few minutes to arrive.
            </p>
            <a href="/login" className={styles.backLink}>← Back to sign in</a>
          </div>
        ) : (
          <>
            <h1 className={styles.heading}>Reset your password</h1>
            <p className={styles.subheading}>
              Enter your email and we'll send you a link to get back into your account.
            </p>

            {error && <div className={styles.errorBanner}>{error}</div>}

            <form className={styles.form} onSubmit={handleSubmit} noValidate>
              <div className={styles.field}>
                <label className={styles.label} htmlFor="email">Email</label>
                <input
                  id="email"
                  type="email"
                  className={styles.input}
                  placeholder="you@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                />
              </div>

              <button type="submit" className={styles.button} disabled={loading}>
                {loading ? <span className={styles.spinner} /> : 'Send reset link'}
              </button>
            </form>

            <p className={styles.footer}>
              Remembered it?{' '}
              <a href="/login" className={styles.link}>Back to sign in</a>
            </p>
          </>
        )}

      </div>
    </div>
  );
}
